import { createTheme } from '@mui/material/styles';

const getTheme = () => {
  const { palette } = createTheme();
  const theme = createTheme({
    palette: {
      primary: {
        main: '#FF5733',
        // light: will be calculated from palette.primary.main,
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      dark: {
        main: '#FF5733',
        // light: will be calculated from palette.primary.main,
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      green: {
        main: '#0B7',
        light: '#FFFFFF',
        dark: "#008051",
        // dark: will be calculated from palette.secondary.main,
        contrastText: '#FFFFFF',
      },
    },
  });
  return theme
}

export { getTheme }